import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import Typography from '@mui/material/Typography';
import { campusesForMapsTopBar } from '../../constants/campuses';

const CampusList = ({ campus, setCampus }) => {
  return (
    <Box className='campus-list'>
      <FormControl fullWidth>
        <Typography variant='h1' component='h2'>
          Location
        </Typography>
        <NativeSelect
          defaultValue={campus}
          value={campus}
          inputProps={{
            name: 'campus',
            id: 'uncontrolled-native',
          }}
          onChange={(event) => setCampus(event.target.value)}
        >
          {campusesForMapsTopBar.map((campus) => {
            const { id, name } = campus;
            return (
              <option key={id} value={id}>
                {name}
              </option>
            );
          })}
        </NativeSelect>
      </FormControl>
    </Box>
  );
};

export default CampusList;
